/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */

import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, Button, Card, Input, Popconfirm, Table, message } from 'antd';
import {
	ReloadOutlined,
	FileExcelOutlined,
	GlobalOutlined,
	QuestionCircleOutlined,
	DeleteOutlined,
} from '@ant-design/icons';
import { useLoadScript } from '@react-google-maps/api';
import { batchDeleteWayPoints, deleteWayPoint, getAllWayPoints, getAllWayPointsFull } from '../../redux/WayPointSlice';
import { getRandomGoogleMapsKey } from '../../redux/googleMapsKeySlice';
import { style } from '../../Styles';
import ActionButton from '../Global/ActionsButton';
import DrawerWayPoints from './DrawerWayPoints';
import ImportCsvsDialog from '../Global/ImportCsvsDialog';
import ModalGoogleMaps from '../Modals/ModalGoogleMaps';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import ViewAllWaypointsWithCluster from './ViewAllWaypointsWithCluster';

const libraries = ['core', 'places', 'geocoding', 'routes', 'geometry'];

const urlAction = 'http://localhost:8080/api/v1/web/way-point/upload/csv?validateOnly=false';
const name_exempleFile = 'sample_way_points_1.csv';

const WayPoints = ({ role }) => {
	const [allPointsModal, setAllPointsModal] = useState(false);
	const { WayPoints } = useSelector((state) => state.wayPoint);
	const [makingApiCall, setMakingApiCall] = useState(false);
	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [sortBy, setSortBy] = useState('locationName');
	const [sortDirection, setSortDirection] = useState('ASC');
	const [selectedRecordId, setSelectedRecordId] = useState(null);
	const [isDrawerOpened, setIsDrawerOpened] = useState(false);
	const [importDialogVisible, setImportDialogVisible] = useState(false);
	const [selectedRecord, setSelectedRecord] = useState(null);
	const [isMapModalOpened, setIsMapModalOpened] = useState(false);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const [allWaypointsData, setAllWaypointsData] = useState([]);

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			setSortBy(sorter.columnKey || sorter.field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('locationName');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};
	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
		selections: [
			Table.SELECTION_ALL,
			Table.SELECTION_INVERT,
			Table.SELECTION_NONE,
			{
				key: 'odd',
				text: 'Select Odd Row',
				onSelect: (changeableRowKeys) => {
					let newSelectedRowKeys = [];
					newSelectedRowKeys = changeableRowKeys.filter((_, index) => {
						if (index % 2 !== 0) {
							return false;
						}
						return true;
					});
					setSelectedRowKeys(newSelectedRowKeys);
				},
			},
			{
				key: 'even',
				text: 'Select Even Row',
				onSelect: (changeableRowKeys) => {
					let newSelectedRowKeys = [];
					newSelectedRowKeys = changeableRowKeys.filter((_, index) => {
						if (index % 2 !== 0) {
							return true;
						}
						return false;
					});
					setSelectedRowKeys(newSelectedRowKeys);
				},
			},
		],
	};
	const refreshImportDialogVisible = (value) => {
		setMakingApiCall(false);
		setImportDialogVisible(value);
	};

	const onSelectRecord = (record) => {
		setSelectedRecord(record);
		setIsMapModalOpened(true);
	};
	const handleDrawerClose = () => {
		setIsDrawerOpened(false);
		setSelectedRecordId(null);
	};

	const handleDrawerOpen = (id) => {
		setIsDrawerOpened(true);
		setSelectedRecordId(id);
	};
	const dispatch = useDispatch();
	const fetchAllWayPoints = () => {
		setMakingApiCall(true);
		dispatch(getAllWayPoints({ page: currentPage - 1, size: pageSize, sortBy, sortDirection, search }))
			.unwrap()
			.then(() => { })
			.catch(() => { })
			.finally(() => {
				setMakingApiCall(false);
			});
	};
	const fetchGoogleMapsKey = () => {
		dispatch(getRandomGoogleMapsKey())
			.then(() => { })
			.catch(() => { });
	};

    const fetchAllWaypointsFull = async () => {
       setMakingApiCall(true);
      try {
        const allData = await dispatch(getAllWayPointsFull()).unwrap();
        setAllWaypointsData(allData);
        setAllPointsModal(true);
     } catch (e) {
        console.error(e);
        message.error('Failed to fetch all waypoints');
     } finally {
        setMakingApiCall(false);
    }
    };



	useEffect(() => {
		fetchAllWayPoints();
	}, [dispatch, currentPage, pageSize, search, sortBy, sortDirection]);

	useEffect(() => {
		fetchGoogleMapsKey();
	}, [dispatch]);

	const handleDelete = (id) => {
		setMakingApiCall(true);
		dispatch(deleteWayPoint({ id }))
			.unwrap()
			.then(() => {
				message.success('Waypoint deleted successfully');
			})
			.catch((e) => {
				console.log('Error deleting Waypoint', e);
				message.error('Error deleting Waypoint');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			sorter: true,
		},
		{
			title: 'Location Name',
			dataIndex: 'locationName',
			key: 'locationName',
			sorter: true,
		},
		{
			title: 'Coordinates',
			render: (text, record) => (
				<Button type='default' size='small' onClick={() => onSelectRecord(record)}>
					Show Map
				</Button>
			),
			key: 'coordinates',
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDelete(record.id)}
					onEdit={() => handleDrawerOpen(record.id)}
				/>
			),

			disabled: !role?.includes('SUPER_ADMIN'),
		},
	];

	const data = WayPoints?.wayPointsList ? Object.values(WayPoints?.wayPointsList) : [];

	const waypointsData = data.map((item) => ({ ...item, key: item.id }));

	const { googleMaps } = useSelector((state) => state.googleMapsKey);

	const { isLoaded } = useLoadScript({
		googleMapsApiKey: googleMaps?.googleMapsKey?.key,
		libraries,
	});

	const handleDeleteBatchWaypoint = () => {
		setMakingApiCall(true);
		dispatch(batchDeleteWayPoints({ wayPointIds: selectedRowKeys }))
			.unwrap()
			.then(() => {
				message.success('Waypoints deleted successfully');
			})
			.catch((e) => {
				console.log('Error deleting Waypoint', e);
				message.error('Error deleting Waypoint');
			})
			.finally(() => {
				setMakingApiCall(false);
				setSelectedRowKeys([]);
			});
	};

	return (
		<>
			<Card style={{ margin: 16 }}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Locations',
								},
								{
									title: 'Waypoints',
								},
							]}
						/>
						<Button type='default' size='small' onClick={() => fetchAllWayPoints()}>
							<ReloadOutlined />
						</Button>
					</div>

					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						{role?.includes('SUPER_ADMIN') && (
							<>
								<Popconfirm
									title='Delete Waypoints'
									description={
										<>
											Are you sure you want to delete{' '}
											<b>{selectedRowKeys.length}</b> waypoints ?
										</>
									}
									onConfirm={() => {
										handleDeleteBatchWaypoint();
									}}
									onCancel={() => {
										setSelectedRowKeys([]);
									}}
									icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
									<Button
										style={{ margin: '0 8px 8px 0' }}
										disabled={selectedRowKeys.length === 0}
										danger>
										Delete
										<DeleteOutlined />
									</Button>
								</Popconfirm>

								<Button
									style={{ margin: '0 8px 8px 0' }}
									onClick={() => {
										setImportDialogVisible(true);
									}}>
									Import
									<FileExcelOutlined />
								</Button>
							</>
						    )}
                             <Button
                                   style={{ margin: '0 8px 8px 0' }}
                                   onClick={fetchAllWaypointsFull}
                             >
                                All Waypoints
                            <GlobalOutlined />
                            </Button>


						<Input.Search
							placeholder='Search'
							style={{ margin: '0 8px 8px 0' }}
							onSearch={(val) => {
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(val);
							}}
							onChange={(e) => {
								const val = e.target.value;
								if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
						/>
						{role?.includes('SUPER_ADMIN') && (
							<Button
								type='default'
								style={{ float: 'right', marginBottom: 8 }}
								onClick={() => setIsDrawerOpened(true)}>
								Add Waypoint
							</Button>
						)}
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={makingApiCall}
					columns={columns.filter((item) => {
						return item.disabled !== true;
					})}
					dataArray={waypointsData}
					handleDoubleClickRow={(record) =>
						role?.includes('SUPER_ADMIN') ? handleDrawerOpen(record?.id) : {}
					}
					handleSelectedRow={() => { }}
					rowSelection={rowSelection}
					onTableChange={handleTableChange}
					pagination={{
						current: currentPage,
						pageSize,
						total: WayPoints.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>
			{isDrawerOpened && (
				<DrawerWayPoints wayPointId={selectedRecordId} onClose={handleDrawerClose} />
			)}
			{importDialogVisible && (
				<ImportCsvsDialog
					setVisible={refreshImportDialogVisible}
					action={urlAction}
					name_exempleFile={name_exempleFile}
					name_file_error='WayPoint'
				/>
			)}
			{isMapModalOpened && (
				<ModalGoogleMaps
					record={selectedRecord}
					setIsMapModalOpened={setIsMapModalOpened}
				/>
			)}
            {isLoaded && allPointsModal && googleMaps?.googleMapsKey?.key && (

                 <ViewAllWaypointsWithCluster
                     isOpen={allPointsModal}
                     setIsOpen={setAllPointsModal}
                     waypoints={allWaypointsData}
                     isLoaded={isLoaded}
                />
  
           )}

		</>

	);
};

export default WayPoints;